(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-gift-product-widget"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('ctrGiftProductWidget', (opts = {}) => ({
      giftProduct: null,
      title: opts.title ?? '',
      currentVariant: null,
      currentVariantId: opts.currentVariantId ?? null,
      variants: [],
      currencyDivider: opts.currencyDivider ?? 100,
      isGiftProductAvailable: false,
      isGiftProductInCart: false,
      pricePattern: opts.pricePattern ?? '[amount]',
      blocked: !!(window.fbSampleGuard && window.fbSampleGuard.blocked),
      adding: false,
      addingTimer: null,

      getData(data) {
        this.giftProduct = data.giftProduct;
        this.title = data.title;
        this.isGiftProductAvailable = data.isGiftProductAvailable;
        this.isGiftProductInCart = data.isGiftProductInCart;
        this.variants = data.giftProduct.variants.filter((variant) => variant.available);
        this.currentVariantId = this.variants[0]?.id ?? null;
        this.currentVariant = this.variants[0] ?? null;
        this.adding = false;
      },

      // Hide the card as soon as the sample is on its way into the cart, so a second tap can't add a second one.
      markAdding() {
        this.adding = true;
        clearTimeout(this.addingTimer);
        this.addingTimer = setTimeout(() => {
          this.adding = false;
        }, 6000);
      },

      formatPrice(price) {
        if (!price) return this.pricePattern.replace('[amount]', '0.00');

        return this.pricePattern.replace('[amount]', (Number(price) / this.currencyDivider).toFixed(2));
      },

      updateCurrentVariant(variantId) {
        this.currentVariantId = variantId;
        this.currentVariant = this.variants.find((variant) => variant.id === this.currentVariantId) ?? null;
      },

      init() {
        this.$watch(
          () => this.currentVariantId,
          (variantId) => {
            this.updateCurrentVariant(Number(variantId));
          }
        );
      },

      addGiftProduct(giftProductId) {},
    }));
  });

  /*
   * Free tea sample guard (drawer and /cart). The sample must never be charged, so:
   * 1. one sample per order: one line, quantity 1 (a second unit or a second line gets no discount and is charged);
   * 2. below the sample amount it comes out (same rule as the drawer bar, now also on /cart);
   * 3. if it still has a price, for example with a discount code that can't be combined with it, it comes out.
   * Every change goes by line key, one at a time, so a fix can never remove the wrong line.
   * Sample lines are marked in cart-products.liquid (data-fb-sample-*).
   */
  (function () {
    if (window.fbSampleGuard) return;

    var STORE_KEY = 'fbSampleBlockedCodes';
    var NOTE_ONE = 'One free sample per order.';
    var NOTE_CODE = "Your discount code can't be used with the free sample, so we took the sample out.";
    var giftIds = new Set();
    var queue = Promise.resolve();
    var timer = null;
    var fixes = 0;
    var blockedCodes = null;
    try {
      blockedCodes = window.sessionStorage.getItem(STORE_KEY);
    } catch (e) {}

    var route = function (name, fallback) {
      var routes = (window.Theme && window.Theme.routes) || {};
      return (routes[name] || fallback) + '.js';
    };

    var config = function () {
      var el = document.querySelector('[data-fb-sample-handles]');
      var handles = el ? el.getAttribute('data-fb-sample-handles').split(',').filter(Boolean) : [];
      var min = el ? Number(el.getAttribute('data-fb-sample-min')) || 0 : 0;
      // Prefer the live reward from the cart progress bar (drawer), so a change in the theme editor carries over.
      try {
        var bar = document.querySelector('.progress__bar > [x-data]');
        var data = null;
        if (bar && window.Alpine && window.Alpine.$data) data = window.Alpine.$data(bar);
        else if (bar && bar._x_dataStack) data = bar._x_dataStack[0];
        var milestone = data && data.milestones ? data.milestones.find(function (m) { return m.product_gift; }) : null;
        if (milestone && milestone.amount) {
          min = Number(milestone.amount);
          if (milestone.product_gift.id) giftIds.add(Number(milestone.product_gift.id));
        }
      } catch (e) {}
      return { handles: handles, min: min };
    };

    var isSample = function (item, handles) {
      return handles.indexOf(item.handle) !== -1 || giftIds.has(Number(item.product_id));
    };

    var codesOf = function (cart) {
      return (cart.discount_codes || [])
        .filter(function (c) { return c.applicable; })
        .map(function (c) { return String(c.code).toUpperCase(); })
        .sort()
        .join(',');
    };

    var note = function (text) {
      document.querySelectorAll('[data-fb-sample-note]').forEach(function (el) {
        if (el.textContent !== text) el.textContent = text;
        el.hidden = !text;
      });
    };

    var setBlocked = function (codes) {
      blockedCodes = codes || null;
      try {
        if (blockedCodes) window.sessionStorage.setItem(STORE_KEY, blockedCodes);
        else window.sessionStorage.removeItem(STORE_KEY);
      } catch (e) {}
      window.dispatchEvent(new CustomEvent('fb-sample-state', { detail: { blocked: !!blockedCodes } }));
    };

    var getCart = function () {
      return fetch(route('cart_url', '/cart'), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      });
    };

    var post = function (path, body) {
      var components = document.querySelectorAll('cart-items-component');
      var ids = [];
      components.forEach(function (c) {
        if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) ids.push(c.dataset.sectionId);
        c.classList.add('cart-items-disabled');
      });
      if (ids.length) {
        body.sections = ids.join(',');
        body.sections_url = window.location.pathname;
      }
      return fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('update ' + r.status);
          return r.json();
        })
        .finally(function () {
          components.forEach(function (c) { c.classList.remove('cart-items-disabled'); });
        });
    };

    // Re-render the drawer or cart page the same way the theme does after a cart change.
    var render = function (cart) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            cart: cart,
            sourceId: 'fb-sample-guard',
            data: { source: 'fb-sample-guard', itemCount: cart.item_count, sections: cart.sections || {} },
          },
        })
      );
    };

    var check = async function () {
      var cfg = config();
      if (!cfg.handles.length && !giftIds.size) return;
      var cart = await getCart();
      var codes = codesOf(cart);
      if (blockedCodes && blockedCodes !== codes) setBlocked(null);
      var lines = cart.items.filter(function (i) { return isSample(i, cfg.handles); });
      if (!lines.length) return note(blockedCodes ? NOTE_CODE : '');
      if (fixes >= 8) return; // safety stop: never loop

      var message = '';
      var changed = null;
      var updates = {};
      var sampleTotal = lines.reduce(function (sum, l) { return sum + (l.final_line_price || 0); }, 0);
      if (cfg.min && cart.total_price - sampleTotal < cfg.min) {
        lines.forEach(function (l) { updates[l.key] = 0; });
      } else {
        lines.forEach(function (l, n) {
          var want = n === 0 ? 1 : 0;
          if (l.quantity !== want) updates[l.key] = want;
        });
        if (Object.keys(updates).length) message = NOTE_ONE;
      }
      if (Object.keys(updates).length) {
        cart = changed = await post(route('cart_update_url', '/cart/update'), { updates: updates });
        fixes += 1;
        lines = cart.items.filter(function (i) { return isSample(i, cfg.handles); });
      }

      var paid = lines.filter(function (l) { return l.final_line_price > 0; });
      if (paid.length) {
        updates = {};
        paid.forEach(function (l) { updates[l.key] = 0; });
        cart = changed = await post(route('cart_update_url', '/cart/update'), { updates: updates });
        fixes += 1;
        if (codes) {
          setBlocked(codes);
          message = NOTE_CODE;
        } else {
          message = '';
        }
      }

      if (changed) render(changed);
      note(message || (blockedCodes ? NOTE_CODE : ''));
    };

    // The sample's remove button (and the drawer bar's own "below the amount" removal) goes by key.
    var removeLine = async function (key) {
      var cart = await getCart();
      if (!cart.items.some(function (i) { return i.key === key; })) return;
      render(await post(route('cart_change_url', '/cart/change'), { id: key, quantity: 0 }));
    };

    var enqueue = function (task) {
      queue = queue.then(task).catch(function (e) {
        console.warn('fb-sample-guard', e);
      });
      return queue;
    };

    var schedule = function (delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        enqueue(check);
      }, delay == null ? 500 : delay);
    };

    document.addEventListener('cart:update', function (event) {
      var data = event.detail && event.detail.data;
      if (data && data.source === 'fb-sample-guard') return;
      schedule();
    });
    document.addEventListener('discount:update', function () {
      schedule();
    });
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target instanceof Element ? event.target.closest('[data-fb-sample-remove]') : null;
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        var key = button.getAttribute('data-fb-sample-remove');
        enqueue(function () {
          return removeLine(key);
        });
      },
      true
    );
    window.addEventListener('cart-progress:display-gift-product', function (event) {
      var gift = event.detail && event.detail.giftProduct;
      if (gift && gift.id) giftIds.add(Number(gift.id));
    });

    window.fbSampleGuard = {
      check: function () {
        schedule(0);
      },
      get blocked() {
        return !!blockedCodes;
      },
    };

    var start = function () {
      if (blockedCodes) note(NOTE_CODE);
      if (blockedCodes || document.querySelector('[data-fb-sample-line]')) schedule(300);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
